<template>
	<div class="mdc-dialog" data-mdc-auto-init="MDCDialog" style="display:block; z-index: 999;" tabindex="0" @click.prevent="leftBtnMethods" @keypress.prevent="leftBtnMethods" v-if="filedata && filedata.resourceUri">
		<div class="mdc-dialog__container" style="opacity:1; transform: scale(1);" @click.stop="" @keypress.stop="" tabindex="0">
					<!-- <i class="material-icons t-color-white t-body1 pdl-8" @click="leftBtnMethods">close</i> -->
					<!-- </button> -->
					<div class="mdc-dialog__surface" style="max-width:522px!important; min-width:522px!important">
					<video-player    
						class="video-player-box board-list-slider "
						v-if="getType(filedata.contentType) === 'video'"
						ref="videoPlayer"
						:options="getPayerOption(filedata)"
						:playsinline="true"
					/>
					<img style="max-width:522px" v-if="getType(filedata.contentType) === 'image'" class="b-radius4" :src="filedata.resourceUri" :alt="filedata.originalName" >
		</div>
		<div class="mdc-dialog__scrim" style="opacity:1;"></div>
		</div>
	</div>
</template>

<script>
import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '../../mixins/topAppBar.js'
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'
import {MDCDialog} from '@material/dialog'
export default {
	components: {
			videoPlayer,
			TopAppBar,
  },
  props: ['filedata'],
    data() {
					return {
						file:null
					}
    },
    mixins: [topAppBarMixin],
    mounted() {
					this.setTopAppBarCloseSocialPopup('')		
					this.file = JSON.parse(localStorage.getItem('socialFile'));
					this.file = this.filedata;
					this.pattenDialog = new MDCDialog(document.querySelector('.mdc-dialog'))
				this.pattenDialog.listen('MDCDialog:opened', () => {
						
				})
				this.pattenDialog.listen('MDCDialog:closed', () => {
			})
					//	console.log('I amgatting',this.file)
				},
		methods : {
		close() {
			this.dialog.listen('MDCDialog:closed', () => {
			})
			this.dialog.close()
		},
		getType(contentType) {
			return contentType.split('/')[0]
		},
		getPayerOption(img) {
			//alert($(window).width())
			return {
				//muted: true,
				language: 'en',
				controls: true,
				playbackRates: [0.7, 1.0, 1.5, 2.0],
				sources: [{
				type: img.contentType,
				src: img.resourceUri
				}],
				height: ($(window).height()-100),
				width: ($(window).width()-10)
			}
		},
		leftBtnMethods(){
			//console.log('my button')
			this.$emit('closePopup')
		}
	}
}
</script>
